import { colors } from './colors';

export const semanticTokens = {
  colors,
};
